import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaAndroid, FaApple } from "react-icons/fa";
import { HiDownload } from "react-icons/hi";

function ProjectCards(props) {
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleOpenModal = () => {
    setActiveIndex(0);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const galleryImages =
    props.screenshots && props.screenshots.length > 0
      ? props.screenshots
      : [props.imgPath];

  return (
    <>
      <Card
        className="project-card-view"
        onClick={handleOpenModal}
        style={{ cursor: "pointer" }}
      >
        <div className="card-img-wrapper">
          <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        </div>
        <Card.Body style={{ display: "flex", flexDirection: "column" }}>
          <Card.Title style={{ color: "purple" }}>{props.subject}</Card.Title>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>

          {/* Action buttons */}
          <div
            style={{ marginTop: "auto" }}
            onClick={(e) => e.stopPropagation()}
          >
            {props.ghLink && (
              <Button variant="primary" href={props.ghLink} target="_blank">
                <BsGithub /> &nbsp;
                {props.isBlog ? "Blog" : "GitHub"}
              </Button>
            )}

            {!props.isBlog && props.demoLink && (
              <Button
                variant="primary"
                href={props.demoLink}
                target="_blank"
                style={{ marginLeft: props.ghLink ? "10px" : "0px" }}
              >
                <CgWebsite /> &nbsp;
                {"Demo"}
              </Button>
            )}

            {props.downloadLink && (
              <Button
                variant="primary"
                href={props.downloadLink}
                target="_blank"
                style={{ marginLeft: props.ghLink || props.demoLink ? "10px" : "0px" }}
              >
                <HiDownload /> &nbsp;
                {"Download"}
              </Button>
            )}

            {props.playStoreLink && (
              <Button
                variant="primary"
                href={props.playStoreLink}
                target="_blank"
                style={{
                  marginLeft:
                    props.ghLink || props.demoLink ? "10px" : "0px",
                  marginTop: "10px",
                }}
              >
                <FaAndroid /> &nbsp;
                {"Android"}
              </Button>
            )}

            {props.appStoreLink && (
              <Button
                variant="primary"
                href={props.appStoreLink}
                target="_blank"
                style={{ marginLeft: "10px", marginTop: "10px" }}
              >
                <FaApple /> &nbsp;
                {"iOS"}
              </Button>
            )}
          </div>
        </Card.Body>
      </Card>

      {/* Demo Screenshots Modal */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        centered
        className="project-gallery-modal"
      >
        <Modal.Header closeButton className="project-modal-header">
          <Modal.Title className="project-modal-title">
            {props.title}{" "}
            <span className="project-modal-subject">
              ({props.subject})
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="project-modal-body">
          {galleryImages.length > 1 ? (
            <Carousel
              activeIndex={activeIndex}
              onSelect={handleSelect}
              interval={null}
              indicators={false}
              slide={true}
            >
              {galleryImages.map((imgSrc, index) => (
                <Carousel.Item key={index}>
                  <div className="project-modal-img-container">
                    <img
                      src={imgSrc}
                      alt={`${props.title} screenshot ${index + 1}`}
                      className="project-modal-img"
                    />
                  </div>
                  <Carousel.Caption className="project-modal-caption">
                    Feature Preview {index + 1} of {galleryImages.length}
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          ) : (
            <div className="project-modal-img-container">
              <img
                src={galleryImages[0]}
                alt={props.title}
                className="project-modal-img"
              />
            </div>
          )}

          {/* Interactive Scrollable Thumbnail Bar */}
          {galleryImages.length > 1 && (
            <div className="modal-thumbnail-bar">
              {galleryImages.map((imgSrc, idx) => (
                <div
                  key={idx}
                  className={`modal-thumbnail-item ${
                    idx === activeIndex ? "active" : ""
                  }`}
                  onClick={() => setActiveIndex(idx)}
                >
                  <img
                    src={imgSrc}
                    alt={`Thumbnail ${idx + 1}`}
                    className="modal-thumbnail-img"
                  />
                  <span className="modal-thumbnail-label">#{idx + 1}</span>
                </div>
              ))}
            </div>
          )}

          <p className="project-modal-description">
            {props.description}
          </p>
        </Modal.Body>
        <Modal.Footer className="project-modal-footer">
          {props.ghLink && (
            <Button
              variant="outline-secondary"
              href={props.ghLink}
              target="_blank"
              size="sm"
            >
              <BsGithub /> &nbsp;GitHub
            </Button>
          )}
          {props.demoLink && (
            <Button
              variant="primary"
              href={props.demoLink}
              target="_blank"
              size="sm"
            >
              <CgWebsite /> &nbsp;Live Demo
            </Button>
          )}
          {props.downloadLink && (
            <Button
              variant="success"
              href={props.downloadLink}
              target="_blank"
              size="sm"
            >
              <HiDownload /> &nbsp;Download
            </Button>
          )}
          <Button variant="secondary" onClick={handleCloseModal} size="sm">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
